<div *ngIf="filteredAttachments.length > 0"
  class="d-flex flex-1-1-auto align-items-center user-select-none card-bottom-img">
  <ng-container *ngFor="let item of filteredAttachments; index as i">
    <img [src]="item" alt="item-img" class="rounded position-absolute card-bottom-img-item"
      [style.right]="(i*14)+'px'" />
  </ng-container>
</div>